var _g;
var _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
var SvgMenuUsers = function SvgMenuUsers(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Vrstva_1",
    x: "0px",
    y: "0px",
    width: "40px",
    height: "40px",
    viewBox: "0 0 40 40",
    enableBackground: "new 0 0 40 40",
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "MU_1_",
    width: 40,
    height: 40
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "MU_2_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#MU_1_",
    overflow: "visible"
  })), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#MU_2_)",
    fill: "none",
    stroke: "#63666A",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    d: "M2.909,30.301 c0-3.426,2.777-6.203,6.203-6.203c3.426,0,6.203,2.777,6.203,6.203"
  }), /*#__PURE__*/React.createElement("circle", {
    clipPath: "url(#MU_2_)",
    fill: "none",
    stroke: "#63666A",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    cx: 9.112,
    cy: 16.825,
    r: 3.817
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#MU_2_)",
    fill: "none",
    stroke: "#63666A",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    d: "M24.684,30.301 c0-3.426,2.777-6.203,6.203-6.203s6.203,2.777,6.203,6.203"
  }), /*#__PURE__*/React.createElement("circle", {
    clipPath: "url(#MU_2_)",
    fill: "none",
    stroke: "#63666A",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    cx: 30.887,
    cy: 16.825,
    r: 3.817
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#MU_2_)",
    fill: "#00C752",
    d: "M24.073,12.723c0,2.214-1.795,4.009-4.008,4.009 c-2.214,0-4.008-1.795-4.008-4.009s1.794-4.008,4.008-4.008C22.278,8.715,24.073,10.509,24.073,12.723"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#MU_2_)",
    fill: "none",
    stroke: "#63666A",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    d: "M25.36,22.531 c-1.102-1.727-3.029-2.876-5.229-2.876c-2.202,0-4.128,1.149-5.23,2.876"
  }))));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMenuUsers, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/menu-users.fc2dee71.svg";
export { ForwardRef as ReactComponent };